const BriefCaseFullIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.44531 4.68125C9.44531 3.8045 10.1561 3.09375 11.0328 3.09375H18.9703C19.8471 3.09375 20.5578 3.8045 20.5578 4.68125V6.26875H28.2429L24.8321 14.7958C24.591 15.3985 24.0072 15.7937 23.3581 15.7937H18.9703V15.2646C18.9703 14.6801 18.4965 14.2062 17.912 14.2062H12.0911C11.5066 14.2062 11.0328 14.6801 11.0328 15.2646V15.7937H6.64503C5.9959 15.7937 5.41216 15.3985 5.17108 14.7958L1.76024 6.26875H9.44531V4.68125ZM18.9703 6.26875H11.0328V5.18125C11.0328 4.90511 11.2567 4.68125 11.5328 4.68125H18.4703C18.7465 4.68125 18.9703 4.90511 18.9703 5.18125V6.26875Z"
        fill="white"
      />
      <path
        d="M25.8147 15.1889L28.4953 8.48733V25.3187C28.4953 26.1955 27.7846 26.9062 26.9078 26.9062H3.09531C2.21856 26.9062 1.50781 26.1955 1.50781 25.3187V8.48732L4.18844 15.1889C4.59024 16.1934 5.56314 16.8521 6.64503 16.8521H11.0328V17.9104C11.0328 18.4949 11.5066 18.9687 12.0911 18.9687H17.912C18.4965 18.9687 18.9703 18.4949 18.9703 17.9104V16.8521H23.3581C24.44 16.8521 25.4129 16.1934 25.8147 15.1889Z"
        fill="white"
      />
      <path
        d="M12.0911 15.4646C12.0911 15.3541 12.1807 15.2646 12.2911 15.2646H17.712C17.8224 15.2646 17.912 15.3541 17.912 15.4646V17.7104C17.912 17.8209 17.8224 17.9104 17.712 17.9104H12.2911C12.1807 17.9104 12.0911 17.8209 12.0911 17.7104V15.4646Z"
        fill="white"
      />
    </svg>
  );
};

export default BriefCaseFullIcon;
